import { styled } from "styled-components";

import { colorCSS, minWidth } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

export const Controls = styled.div<{ alignStart?: boolean }>`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("justify-content", "space-around")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("gap", "1.5rem")}
    ${redundantCssFromKebab("margin-bottom", "1rem")}
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("z-index", "1")}
    justify-content: ${({ alignStart }) =>
        alignStart ? "flex-start" : "flex-end"};
`;

export const DraggableContainer = styled.div`
    ${redundantCssFromKebab("overflow-x", "hidden")}
    ${redundantCssFromKebab("width", "100%")}
    & > div > div {
        ${redundantCssFromKebab("flex-wrap", "nowrap")}
        ${redundantCssFromKebab("padding-bottom", "1rem")}
        ${redundantCssFromKebab("width", "calc(100% + 2rem)")}
    }
    & > div > div > * {
        ${redundantCssFromKebab("flex-shrink", "0")}
        ${redundantCssFromKebab("min-width", "0")}
    }
`;

export const ScrollBar = styled.div`
    ${redundantCssFromKebab("background-color", `${colorCSS("N20")}`)}
    ${redundantCssFromKebab("border-radius", "0.5rem")}
    ${redundantCssFromKebab("height", "1rem")}
    ${redundantCssFromKebab("margin-top", "1rem")}
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("display", "none")}
    @media ${minWidth.sm} {
        ${redundantCssFromKebab("display", "block")}
    }
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("display", "none")}
    }
`;

export const ScrollPosition = styled.div<{
    transitionTimeInSeconds: number;
}>({
    backgroundColor: colorCSS("N80"),
    borderRadius: "0.5rem",
    height: "1rem",
    position: "absolute",
    transition: `left ${({
        transitionTimeInSeconds
    }: {
        transitionTimeInSeconds: number;
    }) => transitionTimeInSeconds}s ease`
});
